<template>
  <div class="getting-started-encouragement">
    <div class="main-container">
      <img class="merchant-collage" src="@/assets/static/img/encouragement/signup-flow-logos.png" />
    </div>
    <img class="plyo-icon" src="@/assets/static/img/icon.png" />
    <div class="caption-text">{{ caption_text }}</div>
  </div>
  
</template>

<script>
  export default {
    data () {
      return {
        caption_text: 'Join our Growing Community!'
      }
    },
  }
</script>
